// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__lkYEX","edit":"styles_edit__IGLvV","row":"styles_row__wqb85","table":"styles_table__mYeHm"};